import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
interface FlightResultsScreenProps {
  onBack: () => void;
  onSelect: () => void;
}
export function FlightResultsScreen({
  onBack,
  onSelect
}: FlightResultsScreenProps) {
  const flights = [{
    id: 1,
    airline: 'Air Sénégal',
    time: '08:00 - 19:30',
    duration: '7h 30m',
    stops: 'Direct',
    price: '485 000',
    logo: 'HC'
  }, {
    id: 2,
    airline: 'Emirates',
    time: '16:45 - 06:15',
    duration: '9h 30m',
    stops: '1 escale',
    price: '520 000',
    logo: 'EK'
  }, {
    id: 3,
    airline: 'Air France',
    time: '23:15 - 14:20',
    duration: '11h 05m',
    stops: '1 escale',
    price: '595 000',
    logo: 'AF'
  }];
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-270">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10 flex items-center gap-4" data-id="element-271">
        <button onClick={onBack} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-272">
          <ArrowLeft size={24} className="text-white" data-id="element-273" />
        </button>
        <div data-id="element-274">
          <h1 className="text-lg font-bold text-white" data-id="element-275">Dakar → Dubaï</h1>
          <p className="text-xs text-white/70" data-id="element-276">Mer. 25 Oct • 1 Passager</p>
        </div>
      </header>

      <div className="px-6 py-4" data-id="element-277">
        <p className="text-sm font-medium text-gray-500 mb-4" data-id="element-278">3 vols trouvés</p>

        <div className="space-y-4" data-id="element-279">
          {flights.map(flight => <Card key={flight.id} className="p-5" data-id="element-280">
              <div className="flex justify-between items-start mb-4" data-id="element-281">
                <div className="flex items-center gap-3" data-id="element-282">
                  <div className="w-10 h-10 bg-[#003366] rounded-lg flex items-center justify-center text-white font-bold text-xs" data-id="element-283">
                    {flight.logo}
                  </div>
                  <div data-id="element-284">
                    <h3 className="font-semibold text-gray-900" data-id="element-285">
                      {flight.airline}
                    </h3>
                    <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-286">
                      <Clock size={12} data-id="element-287" />
                      {flight.duration}
                    </div>
                  </div>
                </div>
                <div className="text-right" data-id="element-288">
                  <div className="text-lg font-bold text-[#003366]" data-id="element-289">
                    {flight.price} FCFA
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-290">par personne</div>
                </div>
              </div>

              <div className="flex justify-between items-center py-3 border-t border-gray-100 mb-3" data-id="element-291">
                <div className="text-sm font-medium text-gray-900" data-id="element-292">
                  {flight.time.split(' - ')[0]}
                </div>
                <div className="flex-1 mx-4 flex flex-col items-center" data-id="element-293">
                  <div className="text-[10px] text-gray-400 mb-1" data-id="element-294">
                    {flight.stops}
                  </div>
                  <div className="w-full h-[1px] bg-gray-300 relative" data-id="element-295">
                    <div className="absolute right-0 top-1/2 -mt-[3px] w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-296"></div>
                    <div className="absolute left-0 top-1/2 -mt-[3px] w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-297"></div>
                  </div>
                </div>
                <div className="text-sm font-medium text-gray-900" data-id="element-298">
                  {flight.time.split(' - ')[1]}
                </div>
              </div>

              <Button fullWidth variant="outline" onClick={onSelect} className="hover:bg-[#D4A017] hover:text-white hover:border-[#D4A017]" data-id="element-299">
                Sélectionner ce vol
              </Button>
            </Card>)}
        </div>
      </div>
    </div>;
}